import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { authAtom, authStsAtom, userAtom, roleAtom } from './core/config/atoms';

import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { jwtDecode } from "jwt-decode";

import PageAuth from './pages/PageAuth';
import PageHome from './pages/PageHome';
import Page404 from './pages/Page404';

import ServiceAuth from 'services/serviceAuth';
import ServiceUtil from 'services/serviceUtil';

export default function App() {

    const [authStatus, setAuthStatus] = useRecoilState(authAtom);
    const [authSts, setAuthSts] = useRecoilState(authStsAtom);
    const [, setUserData] = useRecoilState(userAtom);
    const [, setUserRole] = useRecoilState(roleAtom);

    const authService = new ServiceAuth();
    const utilService = new ServiceUtil();

    const checkUser = () => {
        setUserData(utilService.getDecrypted("user"));
        setUserRole(utilService.getDecrypted("roles"));
        authService.userRefresh().then((res) => {
            if (res.status) {
                setUserData(res.data);
                setAuthSts("org");
                window.location.replace('/');
            } else {
                setAuthStatus(false);
                setAuthSts("open");
                setUserData({});
                setUserRole({});
                localStorage.clear();
                sessionStorage.clear();
                window.location.replace('/');
                toast.error('Error: ' + res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        }).catch((res) => {
            console.log(res);
        });
    }

    useEffect(() => {
        if (authStatus && authSts === "verified") {
            checkUser();
        }
    }, [authStatus]);

    return (
        <>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} newestOnTop={false} rtl={false} theme="light" />
            <Router>
                <Routes>
                    <Route exact path="/" element={<PageAuth />} />
                    {authStatus && <Route exact path="/:page/*" element={<PageHome />} />}
                    {authStatus && <Route exact path="/:page/:id" element={<PageHome />} />}
                    {authStatus && <Route exact path="/:page/:org/:id" element={<PageHome />} />}
                    <Route path="*" element={<Page404 />} />
                </Routes>
            </Router>
        </>
    )
}